import 'leaflet-draw';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement, useEffect } from 'react';
import { useMap } from '../../../../useMap';
import { MOUSE_EVENTS } from '../annotations.interface';

export const MapContextMenuSuppresor = observer((props: PropsWithChildren): ReactElement => {
  const map = useMap();

  useEffect(() => {
    const handleContextMenu = (): void => {
      // do nothing. Prevent browser context menu
    };

    map.on(MOUSE_EVENTS.CONTEXT_MENU, handleContextMenu);

    return (): void => {
      map.off(MOUSE_EVENTS.CONTEXT_MENU, handleContextMenu);
    };
  }, []);

  return <>{props.children}</>;
});
